module.exports = __webpack_public_path__ + "static/img/xinNew3.870349b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xinNew3.jpg
// module id = x5G2
// module chunks = 0